import styled, { css } from 'styled-components';
import { space, color, flexbox, layout, typography } from 'styled-system';

const HeadingStyles = styled.h1`
  ${space}
  ${color}
  ${typography}

  font-weight: bold;
  display: block;

  ${props =>
    props.collapsibleControllerOpened !== undefined &&
    css`
    @media screen and (max-width: 1023px) {
      position: relative;

      &::after {
        width: 10px;
        height: 7px;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='7' viewBox='0 0 10 7'%3e%3cpolyline fill='none' stroke='${props.colors.primary.replace(
          '#',
          '%23',
        )}' stroke-width='2' points='321 24 325 27.769 321.22 31.333' transform='matrix(0 -1 -1 0 32.667 326.667)'/%3e%3c/svg%3e");
        content: '';
        display: block;
        pointer-events: none;
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -3px;
        transform: rotate(180deg);

        ${
          props.collapsibleControllerOpened &&
          css`
            transform: rotate(0deg);
          `
        };
      }
    `};

  ${props =>
    props.textDecoration === undefined &&
    css`
      text-transform: uppercase;
    `};

  ${props =>
    props.color === undefined &&
    css`
      color: ${props.theme.colors.primary};
    `};

  ${props =>
    props.size !== undefined &&
    css`
      font-size: ${props.theme.fontSize[props.size]};
      line-height: ${props.theme.lineHeight[props.size]};
    `}
`;

const LinkStyles = styled.a`
  color: ${props => props.theme.colors.primary};

  &:hover {
    text-decoration: none;
  }
`;

const ParagraphStyles = styled.p`
  ${space}
  ${color}
  ${layout}
  ${flexbox}
  ${typography}

  ${props =>
    props.color === undefined &&
    css`
      color: ${props.theme.colors.gray};
    `};
`;

const TextStyles = styled.span`
  ${space}
  ${color}

  ${props =>
    props.type === 'small' &&
    css`
      font-size: ${props.theme.fontSize[4]};
    `}

    ${props =>
    props.size !== undefined &&
    css`
      font-size: ${props.theme.fontSize[props.size]};
      line-height: ${props.theme.lineHeight[props.size]};
    `}
`;

const ImageStyles = styled.img`
  ${space}

  max-width: 100%;
`;

const BlockStyles = styled.div`
  ${space}
  ${layout}
  ${color}
`;

export default {
  BlockStyles,
  HeadingStyles,
  LinkStyles,
  ParagraphStyles,
  TextStyles,
  ImageStyles,
};
